<template>
  <div class="verval">
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text"> <strong>Daftar</strong> Koordinator Fasilitator</h1>
            <div>
              Modul ini digunakan untuk melihat Daftar Koordinator Fasilitator Sekolah Penggerak
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- <statistik :value="statistik"></statistik>-->
    <!--daftar-->
    <v-card flat>
      <v-card-title class="pa-0">
        <base-table-header @filter="onFilter" @search="onSearch" @reload="onReload">
          <template v-slot:subtitle>
            <div class="body-1 black--text"> Daftar Koordinator</div>
          </template>
          <template v-slot:toolbar>
            <v-select
              style="max-width: 180px"
              class="mr-1"
              v-model="params.pendampingan_tahun"
              light
              flat
              dense
              outlined
              hide-details
              :items="mTahunPendampingan"
              @change="onChangeTahun"
            ></v-select>
            <v-select
              style="max-width: 250px"
              v-model="params.tahun_ke"
              light
              flat
              dense
              outlined
              hide-details
              :items="mTahunPendampinganKe[params.pendampingan_tahun]"
              @change="onChangeTahunKe"
            ></v-select>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter ref="filter" title="Pilih Filter Status" :filtered="filtered" @save="filterSave" />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item, index }">
            <td>
              <v-list>
                <v-list-item class="pa-0">
                  <v-list-item-content class="py-0 my-3">
                    <v-list-item>
                      <v-list-item-avatar color="secondary">
                        <v-icon dark>mdi-account-group</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-row>
                          <v-col cols="12" lg="4">
                            <v-label color="caption"><small>Nama Koordinator Fasilitator</small></v-label>
                            <div class="black--text subtitle-2">
                              {{ $getDeepObj(item, 'nama') || '-' }}
                            </div>
                          </v-col>
                          <v-col cols="12" lg="3">
                            <v-label color="caption"><small>Kontak</small></v-label>
                            <div class="ma-0">
                              <div>{{ $getDeepObj(item, 'no_hp') || '-' }}</div>
                              <div>{{ $getDeepObj(item, 'email') || $getDeepObj(item, 'ptk_id') || '-' }}</div>
                            </div>
                          </v-col>
                          <v-col cols="12" lg="3">
                            <v-label color="caption"><small>Jumlah Anggota</small></v-label>
                            <div class="black--text subtitle-2">
                              <span class="blue--text">
                                {{ ($getDeepObj(item, 'psp_kp_pa_koordinators.data') || []).length }}
                              </span>
                              Fasilitator
                              <span
                                v-if="($getDeepObj(item, 'psp_kp_pa_koordinators.data') || []).length"
                                :class="['ml-2 body-2', view[item.id] ? 'orange--text' : 'blue--text']"
                                style="cursor: pointer"
                                @click="fetchPa(item)"
                              >
                                {{ view[item.id] ? 'Sembunyikan Daftar' : 'Lihat Daftar' }}
                              </span>
                            </div>
                          </v-col>
                          <v-col cols="12" lg="2">
                            <v-list-item-title>
                              <v-label color="caption"><small>Aksi</small></v-label>
                            </v-list-item-title>
                            <v-list-item-subtitle class="link black--text body-2">
                              <v-btn depressed small dark color="blue" @click="onEdit(item)">
                                <v-icon left>
                                  mdi-pencil
                                </v-icon>
                                Pengaturan
                              </v-btn>
                            </v-list-item-subtitle>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                      <v-list-item-action-text>
                        <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                      </v-list-item-action-text>
                    </v-list-item>
                    <div
                      v-for="(pa, id) in listPa && listPa[+item.id]"
                      :key="`${index}-${id}`"
                      class="yellow lighten-5 mb-0"
                    >
                      <v-divider v-if="id !== 0" />
                      <v-list-item>
                        <v-list-item-avatar color="orange">
                          <v-icon dark>mdi-subdirectory-arrow-right</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-row>
                            <v-col cols="12" lg="4">
                              <v-label color="caption"><small>Nama Fasilitator</small></v-label>
                              <div class="black--text subtitle-2">
                                {{ $getDeepObj(pa, 'psp_profil_pa.data.ptk.data.nama') || '-' }}
                              </div>
                            </v-col>
                            <v-col cols="12" lg="3">
                              <v-label color="caption"><small>No. UKG/SIMPKB ID</small></v-label>
                              <div class="black--text subtitle-2">
                                {{
                                  $getDeepObj(pa, 'psp_profil_pa.data.ptk.data.no_ukg') ||
                                    $getDeepObj(pa, 'psp_profil_pa.data.ptk.data.ptk_id') ||
                                    '-'
                                }}
                              </div>
                            </v-col>
                            <v-col cols="12" lg="3">
                              <v-label color="caption"><small>Nama Kelompok Pendampingan</small></v-label>
                              <div class="black--text subtitle-2">
                                {{
                                  $getDeepObj(
                                    pa,
                                    'psp_profil_pa.data.psp_kp_pa_pendampingan_pas.data.0.psp_kp_pa.data.nama'
                                  ) || '-'
                                }}
                              </div>
                            </v-col>
                            <v-col cols="12" lg="2">
                              <v-list-item
                                class="px-0"
                                v-if="
                                  $getDeepObj(
                                    pa,
                                    'psp_profil_pa.data.psp_kp_pa_pendampingan_pas.data.0.psp_kp_pa.data.nama'
                                  )
                                "
                              >
                                <v-list-item-content class="py-0">
                                  <v-list-item-title>
                                    <v-label color="caption"><small>Aksi</small></v-label>
                                  </v-list-item-title>
                                  <v-list-item-subtitle class="link black--text body-2">
                                    <v-btn
                                      small
                                      dark
                                      depressed
                                      color="orange"
                                      @click="
                                        toPendampinganPa(
                                          $getDeepObj(
                                            pa,
                                            'psp_profil_pa.data.psp_kp_pa_pendampingan_pas.data.0.psp_kp_pa.data.id'
                                          )
                                        )
                                      "
                                    >
                                      <v-icon left>mdi-eye</v-icon>
                                      lihat Detail
                                    </v-btn>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </v-col>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full ref="modal" :title="formulir.title" @save="onSave" :use-save="formulir.useSave">
      <component
        ref="formulir"
        :is="formulir.form"
        :initValue="formulir.init"
        :tahun_ke="params.tahun_ke"
        :isPreview="formulir.isPreview"
      />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import actions from './action';
import FormPa from '../formulir/Pa';
export default {
  name: 'Index',
  mixins: [list],
  components: { FormPa },
  data() {
    return {
      actions: actions,
      formulir: {},
      listPa: {},
      view: {},
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('preferensi', {
      diklat: (state) => (state.data && state.data.diklat) || {},
      configPendampingan: (state) => (state.data && state.data.pendampingan) || {},
    }),

    mTahunPendampinganKe() {
      let options = Object.assign(
        {},
        this.$getDeepObj(this.configPendampingan, 'koordinator-pa.pendampingan_tahun_kp') || {}
      );

      for (const key in options) {
        options[key] = (options[key] || []).map((opsi) => {
          const angkatanTahun = opsi.split('|');
          return {
            text: `Angkatan ${angkatanTahun[0]} - Tahun ke-${angkatanTahun[1]}`,
            value: Number(angkatanTahun[1]),
          };
        });
      }

      return options;
    },

    mTahunPendampingan() {
      return Object.keys(this.mTahunPendampinganKe).map((opsi) => {
        return {
          text: `Tahun ${opsi}`,
          value: opsi,
        };
      });
    },

    currTahunKe() {
      const maxTahun = this.$getDeepObj(this.configPendampingan, 'koordinator-pa.tahun') || 2022;
      return maxTahun - 2021 + 1;
    },

    mTahun() {
      let result = [];

      for (let i = this.currTahunKe; i >= 1; i--) {
        result.push({ text: `Tahun ke-${i}`, value: i });
      }

      return result;
    },
  },
  created() {
    if (!this.params.pendampingan_tahun) {
      this.$set(this.params, 'pendampingan_tahun', [...[], ...Object.keys(this.mTahunPendampinganKe)].pop());
      this.$set(this.params, 'tahun_ke', 1);
    }
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('koordinator', ['fetch', 'getDetail', 'action', 'create']),

    fetchPa(data, reset) {
      const id = Number(data && data.id) || '';
      if (!id) return;

      if (!reset && this.view[id]) {
        this.view[id] = false;
        this.$set(this.listPa, id, []);
        return;
      }

      this.$set(this.listPa, id, []);
      this.getDetail({ id, params: { tahun_ke: this.params.tahun_ke } }).then(({ data }) => {
        this.$set(this.listPa, id, (data && data.psp_kp_pa_koordinators && data.psp_kp_pa_koordinators.data) || []);
        this.view[id] = true;
      });
    },

    toPendampinganPa(id) {
      this.$router.push({
        name: 'detail-diklat-pendampingan-pa',
        params: { detail_id: id },
      });
    },

    onChangeTahun() {
      this.params.tahun_ke = null;
    },

    onChangeTahunKe() {
      this.view = {};
      this.listPa = {};
      this.fetchData();
    },

    onEdit(data, preview) {
      this.$set(this.formulir, 'form', 'FormPa');
      this.$set(this.formulir, 'title', 'Kelola PA Anggota Koordinator');
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'isPreview', preview || false);
      this.$set(this.formulir, 'useSave', !preview);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', data);
      });
    },

    onSave() {
      const { form, id } = this.$refs.formulir.getValue();
      const validate = this.$refs.formulir.validate();

      if (!validate) {
        this.$refs.modal.loading = false;
        return;
      }

      this.create({ id, params: form })
        .then(() => {
          this.$success(`Data Fasilitator berhasil diset`);
          this.$refs.modal.close();
          this.onReload();
          this.fetchPa({ id }, true);
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onDelete(item) {
      this.$confirm(
        `<span class="black--text">Anda yakin ingin menghapus data PA untuk Koordinator <strong>${item.nama ||
          '-'}</strong> ?</span>`,
        `Hapus Fasilitator`,
        {
          tipe: 'error',
          data: '',
        }
      ).then(() => {
        this.action({ id: item.id, type: 'delete', params: { tahun_ke: this.params.tahun_ke } }).then(() => {
          this.$success('Data Fasilitator berhasil di hapus');
          this.onReload();
          this.$set(this.listPa, item.id, []);
        });
      });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
